import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Constants } from '@app/constants/constants';
import { MethodsHelper } from '@app/helpers/methods.helper';
import { Branch } from '@app/models/branch';
import { SavingAgreementApproval } from '@app/models/saving-agreement-approval';
import { AuthenticationService } from '@app/services/authentication.service';
import { NotificationService } from "@app/services/notification.service";
import { SavingAgreementsService } from '@app/services/saving-agreements.service';
import {GlobalErrorHandlerService} from "@app/services/global-error-handler.service";
import { SavingAgreementInterestAdjustment } from '@app/models/saving-agreement-interest-adjustment';

@Component({
    selector: 'app-saving-agreement-interest-adjustment-popup',
    templateUrl: './saving-agreement-interest-adjustment-popup.component.html',
    styleUrls: ['./saving-agreement-interest-adjustment-popup.component.css'],
    standalone: false
})

export class SavingAgreementInterestAdjustmentPopupComponent implements OnInit {

  @Input() customerId: string;
  @Input() savingAgreementApproval: SavingAgreementApproval;
  @Input() branches: Array<Branch>;

  @Input() displayDialog: boolean;
  @Output() onSubmit = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  @ViewChild('form') form: any;

  submittedForm: boolean = false;
  adjustmentBranchId: string;

  yearRange: string;
  selectedCurrency: string;
  errorMessage: string | boolean;

  savingAgreementInterestAdjustment: SavingAgreementInterestAdjustment;

  constructor(
    private savingAgreementsService: SavingAgreementsService,
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private errorService: GlobalErrorHandlerService) { }

  ngOnInit(): void {
    this.yearRange = MethodsHelper.getYearRange(0);
    if (!MethodsHelper.haveValue(this.adjustmentBranchId)) {
      this.adjustmentBranchId = this.authenticationService.getCurrentBranchId();
    }
  }

  ngOnChanges() {
    this.savingAgreementInterestAdjustment = new SavingAgreementInterestAdjustment();
    this.savingAgreementInterestAdjustment.customerSpecificOptions = [];
    this.savingAgreementInterestAdjustment.date = MethodsHelper.formatDate(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date());
    this.getSavingAgreementInterestAdjustment();
    this.selectedCurrency = this.savingAgreementInterestAdjustment.currency;
  }

  getSavingAgreementInterestAdjustment() {
    if (this.savingAgreementApproval?.id) {
      this.getInterestAdjustment(this.savingAgreementApproval.id)
    }
  }

  getInterestAdjustment(savingAgreementId) {
    this.savingAgreementsService.getAdjustment(savingAgreementId, this.savingAgreementInterestAdjustment.date).subscribe({
      next: (data) => {
        this.savingAgreementInterestAdjustment = data;
        this.selectedCurrency = this.savingAgreementInterestAdjustment?.currency;
      },
      error: (error) => this.handleError(error)
    });
  }

  saveData() {
    this.submittedForm = true;
    if (this.validateForm()) {
      let submittedData = {
        documentNumber: this.savingAgreementInterestAdjustment.documentNumber,
        date: this.savingAgreementInterestAdjustment.date,
        branchId: this.adjustmentBranchId,
        description: this.savingAgreementInterestAdjustment.description,
        customerSpecificOptions: [
          {
            interestAmount: this.savingAgreementInterestAdjustment.interestAmount,
            customerId: this.customerId
          }
        ],
        initiatedUserId: this.authenticationService.getCurrentUserId(),
        channelCode: Constants.CHANNEL.CHANNEL_CODE,
      };
      this.savingAgreementsService.adjust(this.savingAgreementApproval.id, submittedData).subscribe({
        next: () => {
          this.notificationService.showHTMLMessage("<i class='fa fa-check-circle' style='line-height: 2'></i> <p>" + `Interest adjustment has been successfully done.` + "</p>", "");
          this.onSubmit.emit();
        },
        error: (error) => this.handleError(error)
      });
    }
  }
  
  validateForm() {
    if (this.form.form) {
      return this.form.form.valid
    }
    return false;
  }

  onAmountChange(value) {
    this.savingAgreementInterestAdjustment.interestAmount = value;
  }

  onSave() {
    this.saveData();
  }

  cancel() {
    this.onCancel.emit();
  }

  formatNumber(value) {
    if (value === null || value === undefined || isNaN(value)) return '';
    return MethodsHelper.numberWithCommas(value);
  }

  handleError(error) {
    this.errorMessage = this.errorService.handleError(error);
    if (this.errorMessage) {
      this.notificationService.showErrorMessage(this.errorMessage);
    }
  }

}
